import { useState, useEffect } from 'react';
import { db } from '@/lib/firebase';
import { doc, getDoc } from 'firebase/firestore';
import ConsultingHero from './components/ConsultingHero';
import ConsultingServices from './components/ConsultingServices';
import ConsultingWhoFor from './components/ConsultingWhoFor';
import ConsultingCTA from './components/ConsultingCTA';

const BusinessConsultingPage = () => {
  const [consultingUrl, setConsultingUrl] = useState('/contact');

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const settingsRef = doc(db, 'settings', 'general');
        const docSnap = await getDoc(settingsRef);
        if (docSnap.exists() && docSnap.data().consultingUrl) {
          setConsultingUrl(docSnap.data().consultingUrl);
        }
      } catch (error) {
        console.error('Error fetching consultingUrl:', error);
      }
    };
    fetchSettings();
  }, []);

  return (
    <main className="bg-[#030006] min-h-screen">
      <ConsultingHero consultingUrl={consultingUrl} />
      <ConsultingServices consultingUrl={consultingUrl} />
      <ConsultingWhoFor />
      <ConsultingCTA consultingUrl={consultingUrl} />
    </main>
  );
};

export default BusinessConsultingPage;
